import environment from './_base'

export default environment('dev')
